import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_70objmt9p3: FaireBrandEntity = {
  token: "b_70objmt9p3",
  type: "brand",
  name: "Zab's Datil Pepper Hot Sauce",
  avatarUrl:
    "https://cdn.faire.com/fastly/2b05266fb6d078297dbc33f2969ce084b097744be78265e7e2abe781179eaa79.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/18cc0beb4b6962cd80f6ebe7cd33277be83e2bc85ea4a808322e580820d4424c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/2b05266fb6d078297dbc33f2969ce084b097744be78265e7e2abe781179eaa79.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/18cc0beb4b6962cd80f6ebe7cd33277be83e2bc85ea4a808322e580820d4424c.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 25,
  isTopShop: true,
  isInsider: true,
  description:
    'Enjoy the Slow Burn:  Zab’s hot sauces are made to celebrate the one-of-a-kind history and heat of the rare Datil Pepper.  Despite mysterious origins, Datil Peppers have been grown for 200+ years in St. Augustine, Florida, where they are beloved for their unique "Slow Burn" and naturally sweet heat.  ',
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:19:24.725Z",
    importedBy: "entity-db-cli",
  },
};
